export class CompanyRoles {
  public static readonly Admin = 'Admin';
  public static readonly LeaseApprover = 'Lease Approver';
  public static readonly LeaseSigner = 'Lease Signer';
  public static readonly User = 'User';
  public static readonly LeaseApproverAndSigner = 'Lease Approver & Signer';
  public static readonly TenantOnly = 'Tenant Only';
}
